import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import styled from "styled-components/macro";
import { CTAButton } from "../shared/styles";
import CoachingStatusModule from "./CoachingStatusModule";

const ValueProp = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.body};
  margin: 0 0 ${({ theme }) => theme.spacing.md};
  line-height: 1.55;
`;

const BulletList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 ${({ theme }) => theme.spacing.md};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs};
`;

const BulletItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing.xs};
  font-size: 14px;
  color: ${({ theme }) => theme.colors.body};
  line-height: 1.5;
  &::before {
    content: "\u2022";
    color: ${({ theme }) => theme.colors.body};
    flex-shrink: 0;
    margin-top: 1px;
  }
`;

const BookButtonContent = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.xs};
`;

/**
 * GPDS-890 — OD15 panel module (Tier 2)
 * Eligibility statement, value prop, and CTA linking to the OD booking URL.
 * Booking URL is sourced from backend/HubSpot seat config.
 */
export default function OD15Module({ data, onBookingAction, bookingUrl }) {
  if (data?.sessions?.length) {
    return (
      <CoachingStatusModule
        ownSessions={data.sessions}
        nextIndividualSession={data.sessions[0]}
        onBookingAction={onBookingAction}
        sessionTitle="CoachConnect 15"
      />
    );
  }
  return (
    <>
      <ValueProp>
        A free and confidential 15-minute session with an executive coach to
        help you with:
      </ValueProp>
      <BulletList>
        <BulletItem>Tailor your platform journey</BulletItem>
        <BulletItem>Make confident decisions</BulletItem>
        <BulletItem>Unblock challenges</BulletItem>
        <BulletItem>Navigate key leadership moments</BulletItem>
      </BulletList>
      <CTAButton
        href={bookingUrl || "#"}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => {
          onBookingAction(data?.id, "od15");
        }}
      >
        <BookButtonContent>
          Book Session
          <FontAwesomeIcon icon={faArrowRight} size="sm" />
        </BookButtonContent>
      </CTAButton>
    </>
  );
}
